<template>
  <footer>
    <div class="bg" :class="this.$route.name == 'submit a ticket' ? 'ticket' : this.$route.name">
      <div class="animals">
        <div class="footer-animals"><img data-lazy="" alt="party animals" src="../assets/images/common/footer_aimals.png"
            data-src="../assets/images/common/footer_aimals@2x.png" class=""></div>
        <div class="wall"></div>
      </div>
      <div class="icon">
        <div class="container">
          <div class="icon-box">

            <div class="icon-list footer-cn">
              <a data-v-40ab164b="" href="https://weibo.com/u/7467641158" target="_blank"
                class="footer-icon-item footer-weibo">
                <svg data-v-40ab164b="" style="width: 34px; height: 27.5px; fill: #c9bcb3" id="weibo"
                  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25.85 20.89">
                  <title data-v-40ab164b="">weibo</title>
                  <path data-v-40ab164b="" style="fill: #c9bcb3"
                    d="m 12.27,11.56 c -0.916274,-0.682909 -2.080885,-0.941307 -3.2,-0.71 -1.85,0.27 -3.69,1.94 -3.52,3.67 -0.080195,1.192713 0.5898675,2.309484 1.68,2.8 1.6356609,0.866714 3.640306,0.60611 5,-0.65 1.699191,-1.271347 1.71908,-3.812208 0.04,-5.11 z M 8.12,16.15 C 7.4966233,16.226804 6.9576011,15.716658 7,15.09 c 0.067647,-0.725879 0.6810238,-1.278353 1.41,-1.27 0.72,0 1.17,0.37 1.18,1 -0.058295,0.763733 -0.7042608,1.348179 -1.47,1.33 z m 2.05,-2 c -0.2521947,0.03876 -0.4757186,-0.165329 -0.46,-0.42 0.02593,-0.284077 0.2647444,-0.501181 0.55,-0.5 0.28,0 0.46,0.14 0.46,0.38 0.009,0.392579 -0.332173,0.531744 -0.55,0.54 z"
                    class="weibo-path1"></path>
                  <path data-v-40ab164b="" style="fill: #c9bcb3"
                    d="M 19.204844,9.843125 C 18.204844,9.423125 18.24,9.48 18.55,8.47 19.091241,7.179342 18.129372,5.7576782 16.73,5.78 16.345934,5.71658 15.954066,5.71658 15.57,5.78 14.73,5.96 13.91,6.21 13.08,6.43 L 12.15,6.67 C 12.27,6.03 12.37,5.57 12.43,5.1 12.703353,3.8662257 11.68674,2.7276193 10.43,2.86 9.8703731,2.85762 9.3148746,2.955849 8.79,3.15 c -3.7022424,1.4777648 -6.675797,4.3507644 -8.28,8 -0.79926385,1.601973 -0.68102662,3.509025 0.31,5 0.7935957,1.146821 1.896297,2.044933 3.18,2.59 3.5846433,1.688691 7.682738,1.928702 11.44,0.67 2.25746,-0.621878 4.225111,-2.01622 5.56,-3.94 0.550256,-0.754601 0.819126,-1.677955 0.76,-2.61 -0.165645,-1.410161 -1.151199,-2.588113 -2.51,-3 z M 15.24,17.01 c -1.443356,0.942957 -3.101061,1.50699 -4.82,1.64 -1.7082891,0.18809 -3.4356784,-0.08829 -5,-0.8 C 4.0053167,17.338848 2.9767619,16.103817 2.73,14.62 2.584066,13.566553 2.9307027,12.504517 3.67,11.74 5.0802463,10.19932 7.0035231,9.2252391 9.08,9 c 2.04691,-0.3445631 4.150368,-0.022033 6,0.92 1.347323,0.624018 2.250628,1.929218 2.36,3.41 -0.103422,1.512826 -0.934922,2.881259 -2.23,3.67 z"
                    class="weibo-path2"></path>
                  <path data-v-40ab164b="" style="fill: #c9bcb3"
                    d="m 20.42,8.11 c 0.53,0.12 0.92,-0.19 1.08,-0.84 0.464233,-2.1272378 -1.259964,-4.0977475 -3.43,-3.92 -0.69,0.05 -1,0.37 -1,0.9 0,0.53 0.34,0.77 1.1,0.76 1.089773,-0.1389709 1.985232,0.8491226 1.74,1.92 C 19.76,7.6 19.94,8 20.42,8.11 Z M 18.37,0 h -0.84 c -0.128541,0.0116619 -0.255741,0.03509346 -0.38,0.07 -0.69,0.16 -1,0.6 -0.91,1.16 0.09,0.56 0.58,0.83 1.29,0.72 1.310061,-0.2483876 2.66308,0.091696 3.7,0.93 1.54026,1.1583545 2.188298,3.1584726 1.62,5 -0.2,0.81 0.2,1.46 0.9,1.41 0.7,-0.05 0.88,-0.53 1,-1.08 C 25.823763,4.0446379 22.67152,-0.01177601 18.37,0 Z"
                    class="weibo-path3"></path>
                </svg></a>
              <a data-v-40ab164b="" class="footer-icon-item footer-wechat"><svg data-v-40ab164b=""
                  style="fill: #c9bcb3; width: 34px; height: 27.6px" id="图层_1" data-name="图层 1"
                  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25.85 20.89">
                  <title data-v-40ab164b="">wechat</title>
                  <path data-v-40ab164b=""
                    d="M18.49,6.42a6.91,6.91,0,0,0-2.83-4.37,10.28,10.28,0,0,0-8-1.91A9.12,9.12,0,0,0,1.54,3.49C-1,6.69-.32,10.8,2.88,13.34a1.11,1.11,0,0,1,.5,1.44A16.66,16.66,0,0,0,3,16.53c.42-.18.64-.27.85-.38.56-.31,1.09-.68,1.67-.94a1.81,1.81,0,0,1,.93-.07c1.09.14,2.18.31,3.35.48C8.36,10.76,12.6,6.27,18.49,6.42Zm-6-2.5A1.37,1.37,0,0,1,13.76,5.2a1.4,1.4,0,0,1-1.32,1.38,1.49,1.49,0,0,1-1.33-1.32A1.39,1.39,0,0,1,12.49,3.93ZM6.18,6.57A1.35,1.35,0,0,1,4.94,5.21,1.23,1.23,0,0,1,6.22,3.93,1.25,1.25,0,0,1,7.46,5.24,1.36,1.36,0,0,1,6.18,6.57ZM22.09,8.1a9,9,0,0,0-5.56-.78,7.48,7.48,0,0,0-5.09,3,5.65,5.65,0,0,0,1.41,8.13,8.93,8.93,0,0,0,7.67,1.39,1.53,1.53,0,0,1,.92.13c.61.29,1.18.65,1.77,1l.13-.14a7.68,7.68,0,0,0-.29-1.24,1,1,0,0,1,.38-1.25A11.15,11.15,0,0,0,24.7,17a5.11,5.11,0,0,0,1.14-3.64A6.21,6.21,0,0,0,22.09,8.1Zm-6.65,4.52a1.07,1.07,0,0,1-1-1.11,1,1,0,0,1,1.13-1,1,1,0,0,1,1,1.07A1,1,0,0,1,15.44,12.62Zm5.25,0a1.17,1.17,0,0,1-1.13-1.09,1.17,1.17,0,0,1,1.08-1.06,1.07,1.07,0,1,1,.05,2.14Z"
                    transform="translate(0)" class="cls-1"></path>
                </svg>

                <span class="qr-code"><img alt="party animals 二维码"
                    src="../assets/images/new/wechat_qrcode@2x.png" /><br />扫一扫关注我们
                </span>
              </a>
              <a data-v-40ab164b="" href="https://space.bilibili.com/614485978?spm_id_from=333.337.search-card.all.click"
                target="_blank" class="footer-icon-item footer-bilibili"><svg data-v-40ab164b="" style="fill: #c9bcb3"
                  version="1.1" id="图层_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                  x="0px" y="0px" viewBox="0 0 296.6 281.3" xml:space="preserve">
                  <g data-v-40ab164b="">
                    <path data-v-40ab164b="" d="M86.2,41.9C82,36,78,30.9,74.4,25.5C69.5,18.2,73.5,8.7,81,3.3c7.1-5.2,19-3.7,24,3.3c7.3,10.1,14,20.6,21.2,30.8
                            		c1.1,1.6,2.7,2.5,4.5,2.6c12.8,0.3,21.3,0.3,34.1,0c1.7,0,3.9-1.5,4.9-3c7.1-10.1,13.7-20.5,20.8-30.5c5.2-7.4,16.4-8.5,23.9-3.3
                            		c7.7,5.4,11.3,14.1,6.2,21.7c-1.9,2.8-3.8,5.4-5.8,8.1c-1.8,2.5-3.7,5-6.1,8.2c10.3,0.7,18.2,1.3,27.7,1.9
                            		c10.9,0.7,21.6,1.7,31.2,7.5c15.5,9.5,24,23.4,25.2,41.3c1.7,24.2,3.7,48.5,3.6,72.8c-0.1,23.4-2,46.9-4.5,70.2
                            		c-2.3,21.9-22.6,40.2-44.4,42.2c-46.2,4.1-92.5,5.1-138.8,3.5c-20.1-0.7-40.2-2.1-60.3-3.7c-22.8-1.7-43-21.6-45.2-44.4
                            		c-3.3-33.9-4.2-67.8-2.6-101.8c0.7-14.8,1.7-29.6,3.6-44.3c3-23.2,22.9-41,46.2-42.4c11.3-0.7,21.3-1.4,32.5-2.2
                            		C84.2,41.8,84.4,42.3,86.2,41.9z M148.4,253c31.7-1.7,63.5-3.3,95.2-5c9.5-0.5,17.9-7.8,19.5-17.2c1.3-7.5,1.6-15.2,2.3-22.8
                            		c3.4-38.8,2.5-77.5-2.1-116.2c-1.2-10-9.2-18.1-19.2-18.6c-28.4-1.5-56.9-3.7-85.3-3.6c-34.9,0.1-69.9,2.2-104.8,3.6
                            		c-11.4,0.5-19.5,7.8-20.9,19c-1.1,8.2-1.4,16.6-2.1,24.9c-2.9,37.1-1.9,74.2,1.4,111.3c1,10.7,9.7,19,20.6,19.6
                            		C84.8,249.8,116.5,251.4,148.4,253z"></path>
                    <path data-v-40ab164b="" d="M121.8,129.3c0.1,5.1-2.2,9.8-7.1,11.6c-16.5,5.8-32.9,11.8-49.4,17.6c-6,2.1-10.9-1.5-13.4-7.3c-2.8-6.5-1.8-14.7,4-16.9
                            		c17.4-6.5,35-12.6,52.7-18.3C115.2,113.8,121.7,121.5,121.8,129.3z"></path>
                    <path data-v-40ab164b=""
                      d="M245.3,147.5c-1.3,10.4-6.4,13.7-15.6,10.4c-15.9-5.6-31.9-11.3-47.8-17.1c-6.4-2.3-8.8-8.7-6.7-15.2
                            		c2.1-6.9,7.3-11.5,14.1-9.3c16.7,5.5,33.2,11.4,49.8,17.2C243.8,135.2,246.4,139.7,245.3,147.5z">
                    </path>
                    <path data-v-40ab164b=""
                      d="M148.5,189.8c-3,3.1-6.5,6.6-10.6,8.7c-9.2,4.7-21,2.6-26.9-5.9c-3.5-5-5.9-9.8-8-15.6c-1-3,0.3-7.7,4.1-8.4
                            		c3.7-0.8,5.8,1.1,6.8,4.4c1.1,3.5,2.1,6.2,4.1,9.2c4.9,7.8,13.1,7.4,18.3,1.3c2.2-2.7,3.9-5.4,6-8.1c1.3-1.8,3.8-4.1,5.8-4.1
                            		c2,0.1,4.5,1.9,5.9,3.8c2,2.6,3.9,6.2,6.4,9c5,5.8,12.4,6.2,17.1-1.2c2-3.2,3.3-6.6,4.6-10.1c1.2-3.3,3.5-5.1,7.1-4.1
                            		c3.7,1,5.1,5.1,3.9,8.3c-2,5.4-4.1,10-7.4,14.6c-8.6,12-24.6,12.4-34.5,1.3C150.2,191.8,149.2,190.5,148.5,189.8z">
                    </path>
                  </g>
                </svg>
              </a>

              <a data-v-40ab164b=""
                href="https://www.douyin.com/user/MS4wLjABAAAABjpPMMrwYPFBWZQB0MrsACEwFNgtshEj0YCfxFrAvVNGPitHrtLcNzsDP7yNBZs7"
                target="_blank" class="footer-icon-item footer-tiktok"><svg version="1.1" id="图层_1"
                  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                  viewBox="0 0 25.3 25.3" style="fill: #c9bcb3; enable-background: new 0 0 25.3 25.3"
                  xml:space="preserve">
                  <path class="st0" d="M19.8,0H5.5C2.5,0,0,2.5,0,5.5v14.3c0,3,2.5,5.5,5.5,5.5h14.3c3,0,5.5-2.5,5.5-5.5V5.5C25.3,2.5,22.8,0,19.8,0z
                            	 M21.3,10.9c-1.7,0-3.4-0.6-4.7-1.5c0,0,0,6.7,0,6.9c0,3.4-2.8,6.2-6.2,6.2s-6.2-2.8-6.2-6.2s2.8-6.2,6.2-6.2c0.3,0,0.5,0,0.8,0.1
                            	v3.5c-0.3-0.1-0.5-0.1-0.8-0.1c-1.6,0-2.8,1.3-2.8,2.8s1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0,0,0,0,0,0h0V2.9h0h3.3h0v0.5
                            	c0.3,2.4,2.3,4.2,4.7,4.2V10.9z" />
                </svg></a>

              <a data-v-40ab164b=""
                href="https://www.xiaohongshu.com/user/profile/610911670000000001016cbc?xhsshare=CopyLink&appuid=594fbbf782ec397bde1c99d4&apptime=1691117519"
                target="_blank" class="footer-icon-item footer-tiktok">
                <svg id="\u56FE\u5C42_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                  x="0px" y="0px" viewBox="0 0 25.3 25.3" xml:space="preserve" class="w-full h-full"
                  style="width:29px; height: 29px; margin: 0px auto;fill:#C9BCB3;">

                  <g>
                    <path class="shu"
                      d="M20,10.3c-0.2,0-0.3,0-0.5,0c0,0.4,0,0.8,0,1.1c0.2,0,0.5,0,0.7,0c0-0.3,0-0.6,0-0.9 C20.2,10.4,20.1,10.3,20,10.3z">
                    </path>
                    <path class="shu"
                      d="M19.8,0H5.5C2.5,0,0,2.5,0,5.5v14.3c0,3,2.5,5.5,5.5,5.5h14.3c3,0,5.5-2.5,5.5-5.5V5.5C25.3,2.5,22.8,0,19.8,0 z M9.2,10.8c0.4-0.7,0.7-1.5,1.1-2.2c0-0.1,0.1-0.1,0.2-0.1c0.4,0,0.8,0,1.2,0c0.2,0,0.2,0,0.1,0.1c-0.3,0.6-0.6,1.1-0.9,1.7 c0,0.1,0,0.2,0,0.2c0,0.1,0.2,0.1,0.2,0l0.1-0.1c0.4,0,0.9,0,1.3,0c-0.1,0.2-0.2,0.5-0.3,0.7c-0.3,0.5-0.5,1.1-0.8,1.6 c-0.1,0.2-0.1,0.3,0.2,0.3c0.2,0,0.4,0,0.7,0c-0.2,0.4-0.4,0.7-0.6,1.1c0-0.1,0,0-0.1,0c-0.5,0-1,0-1.5,0c-0.3,0-0.4-0.2-0.4-0.5 c0-0.2,0.1-0.3,0.1-0.4c0.2-0.4,0.4-0.9,0.6-1.3c0,0,0-0.1,0.1-0.2c-0.1,0-0.1,0-0.2,0c-0.3,0-0.5,0-0.8,0c-0.3,0-0.4-0.1-0.4-0.4 C9.1,11.1,9.2,11,9.2,10.8z M3,14.8c-0.1,0.2-0.2,0.3-0.3,0.4c-0.1-0.2-0.2-0.4-0.3-0.6c-0.1-0.3-0.3-0.5-0.4-0.8 c0-0.1,0-0.1,0-0.2c0.3-1.1,0.4-2.1,0.3-3.2c0,0,0,0,0-0.1c0.5,0,1,0,1.4,0c0,1.3-0.1,2.5-0.4,3.7C3.2,14.3,3.1,14.5,3,14.8z  M6,8.5c0,2.1,0,4.1,0,6.2c0,0.2,0,0.6-0.1,0.8s-0.4,0.4-0.6,0.4c-0.2,0-0.4,0-0.7,0c-0.5-0.1-0.9-0.6-0.9-1.2c0.2,0,0.5,0,0.7,0 s0.2,0,0.2-0.2c0-2,0-4,0-6c0-0.1,0-0.1,0-0.2c0.5,0,1,0,1.4,0C6,8.4,6,8.4,6,8.5z M8.8,13.8c-0.2,0.5-0.5,0.9-0.8,1.4 c-0.2-0.1-0.3-0.3-0.4-0.4c-0.2-0.5-0.3-1-0.4-1.5C7.1,12.4,7,11.4,7,10.5v-0.1c0.5,0,1,0,1.5,0c0,0.1,0,0.2,0,0.3 C8.5,11.7,8.6,12.7,8.8,13.8L8.8,13.8z M11,15.8c0,0.1-0.1,0.1-0.2,0.1c-0.5,0-1.1,0-1.6,0c-0.1,0-0.1,0-0.2,0 c-0.2-0.1-0.2-0.1-0.1-0.3c0.2-0.4,0.4-0.8,0.6-1.2c0.2,0.1,0.3,0.1,0.4,0.1c0.5,0,1,0,1.6,0c0.1,0,0.1,0,0.2,0 c0,0.1-0.1,0.2-0.1,0.2C11.4,15.1,11.2,15.5,11,15.8z M11.7,16c0.2-0.3,0.3-0.6,0.5-0.9c0.2-0.4,0.4-0.4,0.7-0.4c0.3,0,0.6,0,0.8,0 c0-1.4,0-2.8,0-4.2c-0.3,0-0.6,0-0.9,0c0-0.5,0-1,0-1.5C13.9,9,15,9,16,9c0,0.5,0,1,0,1.4c-0.3,0-0.6,0-0.9,0c0,1.4,0,2.8,0,4.2 c0.5,0,0.9,0,1.4,0c0.1,0.5,0.1,0.9,0.1,1.4C15,16,13.4,16,11.7,16z M23,14.9c0,0.5-0.3,1-0.9,1.1c-0.2,0-0.4,0-0.7,0 c-0.6-0.1-1-0.6-1-1.2c0.2,0,0.5,0,0.7,0s0.3,0,0.5,0c0.1,0,0.1,0,0.1-0.1c0-0.5,0-0.9,0-1.4c0-0.2-0.1-0.4-0.3-0.4 c-0.6,0-1.3,0-1.9,0c0,0,0,0-0.1,0c0,0.1,0,0.1,0,0.2c0,0.9,0,1.8,0,2.7c0,0.2,0,0.2-0.2,0.2c-0.4,0-0.8,0-1.2,0c0-1,0-2,0-3.1 c-0.5,0-0.9,0-1.4,0c0-0.5,0-1,0-1.4c0.5,0,0.9,0,1.4,0c0-0.4,0-0.7,0-1.1c-0.3,0-0.6,0-0.9,0c0-0.5,0-1,0-1.4c0.3,0,0.6,0,0.9,0 c0-0.2,0-0.3,0-0.5c0.5,0,0.9,0,1.4,0c0,0.1,0,0.2,0,0.3s0,0.1,0.1,0.1c0.2,0,0.5,0,0.7,0c0.8,0.1,1.3,0.8,1.3,1.6c0,0.3,0,0.6,0,1 c0.1,0,0.2,0,0.3,0c0.7,0.1,1.2,0.7,1.2,1.4C23,13.6,23,14.2,23,14.9z M22.5,10.3c-0.3,0-0.5,0-0.8,0c0.1-0.3,0.1-0.6,0.1-0.9 c0.1-0.3,0.4-0.5,0.7-0.5c0.3,0,0.6,0.3,0.6,0.7C23.1,10,22.9,10.3,22.5,10.3z">
                    </path>
                  </g>
                </svg>


              </a>
              <a data-v-40ab164b="" target="_blank" href="https://www.youtube.com/c/PartyAnimalsGame"
                class="footer-icon-item footer-youtube"><svg style="fill: #c9bcb3; width: 32px; height: 22.5px"
                  data-v-40ab164b="" version="1.1" id="图层_1" xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 34.3 24.2" xml:space="preserve">
                  <path data-v-40ab164b="" d="M17.2,0c3.9,0.1,7.6,0.1,11.3,0.4c0.8,0.1,1.7,0.2,2.5,0.5c1.2,0.4,2,1.2,2.5,2.4c0.5,1.2,0.6,2.5,0.7,3.8
                            	c0.2,2.2,0.3,4.5,0.2,6.7c-0.1,1.5-0.2,3.1-0.3,4.6c-0.1,0.9-0.2,1.8-0.6,2.6c-0.7,1.4-1.8,2.2-3.3,2.4c-3,0.5-6,0.5-9.1,0.5
                            	c-1.8,0-3.7,0.1-5.5,0c-3.2,0-6.4-0.1-9.5-0.4c-0.8-0.1-1.7-0.2-2.5-0.5c-1.2-0.4-2.1-1.3-2.5-2.5c-0.4-1.1-0.5-2.3-0.6-3.4
                            	c-0.2-2.3-0.3-4.6-0.2-6.9c0.1-1.7,0.2-3.3,0.4-5c0.1-1,0.2-1.9,0.7-2.8c0.7-1.3,1.8-2,3.2-2.2c2.6-0.4,5.2-0.5,7.8-0.5
                            	C13.9,0,15.7,0,17.2,0z M13.7,17.2c0.1-0.1,0.2-0.1,0.3-0.2c1-0.6,2.1-1.2,3.1-1.8c1.7-1,3.5-2,5.2-3c0.1-0.1,0.2-0.1,0.2-0.2
                            	c-0.1-0.1-0.2-0.2-0.2-0.2c-0.5-0.3-1-0.6-1.5-0.8c-2.1-1.2-4.2-2.4-6.3-3.6C14.2,7.3,14,7.2,13.7,7C13.7,10.4,13.7,13.8,13.7,17.2z
                            	"></path>
                </svg>
              </a>


            </div>
            <div class="icon-list footer-en">
              <a href="https://twitter.com/party_animals" target="_blank" class="footer-icon-item footer-twitter">
                <svg version="1.1" id="图层_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                  x="0px" y="0px" viewBox="0 0 25.1 22.6" xml:space="preserve"
                  style="width: 33px; height: 25px; fill: rgb(201, 188, 179);">

                  <path class="st0" d="M0,0c0.5,0,0.9,0,1.3,0C3.6,0,6,0,8.3,0c0.4,0,0.7,0.1,1,0.5c1.2,1.7,2.4,3.3,3.5,5c0.4,0.6,0.9,1.2,1.4,1.9
	c0.6-0.6,1.1-1.2,1.7-1.8c1.6-1.7,3.3-3.5,4.9-5.3C21,0.1,21.3,0,21.6,0c0.9,0,1.8,0,2.8,0c-0.1,0.2-0.2,0.3-0.2,0.3
	c-2.6,2.7-5.2,5.5-7.8,8.2c-0.1,0.1-0.2,0.2-0.3,0.4c-0.4,0.4-0.4,0.4,0,0.9c2.3,3.3,4.7,6.5,7,9.8c0.6,0.8,1.2,1.7,1.8,2.5
	c0.1,0.1,0.1,0.2,0.2,0.4c-0.1,0-0.2,0-0.3,0c-2.7,0-5.4,0-8,0c-0.4,0-0.6-0.1-0.8-0.4c-1.7-2.4-3.4-4.8-5.1-7.1
	c0-0.1-0.1-0.1-0.2-0.2c-0.6,0.7-1.3,1.3-1.9,2c-1.7,1.9-3.5,3.7-5.3,5.6c-0.1,0.1-0.3,0.2-0.4,0.2c-0.9,0-1.9,0-2.8,0
	c0,0-0.1,0-0.2-0.1c0.3-0.3,0.5-0.5,0.7-0.8c2.7-2.9,5.5-5.8,8.2-8.7c0.2-0.2,0.1-0.3,0-0.5C6,8.4,3.1,4.4,0.2,0.3
	C0.1,0.2,0.1,0.2,0,0z M20.5,20.1c-0.1-0.2-0.2-0.3-0.3-0.4c-1.9-2.6-3.8-5.2-5.6-7.8c-2.2-3.1-4.5-6.2-6.7-9.3
	C7.8,2.6,7.7,2.4,7.6,2.4c-1,0-1.9,0-3,0c0.1,0.2,0.2,0.3,0.3,0.5c2.7,3.7,5.3,7.4,8,11c1.4,2,2.9,4,4.3,5.9
	c0.1,0.1,0.2,0.3,0.4,0.3C18.5,20.2,19.5,20.1,20.5,20.1z" />
                </svg>
              </a>
              <a href="https://discord.com/invite/NKA3UEs3eR" target="_blank" class="footer-icon-item footer-discord">
                <svg version="1.1" id="图层_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                  x="0px" y="0px" viewBox="0 0 32.8 24.8" style="
                                              width: 33px;
                                              height: 25px;
                                              fill: #c9bcb3;
                                              enable-background: new 0 0 32.8 24.8;
                                            " xml:space="preserve">
                  <path class="st0" d="M32.6,14.7c-0.2-1.6-0.5-3.1-0.9-4.6c-0.9-2.9-2.2-5.5-3.8-8c-0.1-0.1-0.1-0.1-0.2-0.2
                            	c-1.9-0.8-3.8-1.4-5.8-1.9C21.6,0.1,21.3,0.1,21,0c-0.3,0.6-0.6,1.2-0.9,1.8c-2.5-0.4-5-0.4-7.5,0c-0.3-0.6-0.5-1.2-0.9-1.7
                            	c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0C9.3,0.4,7.2,1.1,5.2,2C5,2.1,5,2.1,4.9,2.2c-1.1,1.6-2,3.3-2.8,5C0.7,10.6,0,14,0,17.6
                            	c0,0.9,0,1.9,0.1,2.8c0,0.2,0.1,0.3,0.2,0.4c2.4,1.7,5,3,7.8,3.9c0.1,0,0.2,0.1,0.3,0.1c0.7-0.9,1.3-1.8,1.8-2.9
                            	c-1-0.4-1.9-0.8-2.8-1.3c0.2-0.1,0.3-0.2,0.5-0.4c0.1-0.1,0.2-0.1,0.4,0c2.2,1,4.5,1.6,6.9,1.7c1.1,0.1,2.3,0,3.4-0.1
                            	c2-0.2,3.9-0.8,5.8-1.6c0.1,0,0.1-0.1,0.2-0.1c0.1,0.1,0.2,0.2,0.3,0.3c0.1,0.1,0.2,0.2,0.4,0.3c-0.5,0.3-0.9,0.5-1.4,0.7
                            	c-0.5,0.2-0.9,0.4-1.4,0.6c0.3,0.6,1.3,2.3,1.8,2.8c0.1,0,0.1,0,0.1,0c0.9-0.3,1.7-0.6,2.5-0.9c1.9-0.8,3.8-1.8,5.5-3.1
                            	c0.1-0.1,0.2-0.2,0.2-0.3c0-0.5,0.1-1,0.1-1.4C32.8,17.6,32.7,16.2,32.6,14.7z M13.1,15.9c-1.1,1.3-2.9,1.4-4.1,0.2
                            	c-1.3-1.3-1.3-3.6,0-4.9c1.1-1.2,2.9-1.1,4,0.1c0.6,0.6,0.9,1.4,0.9,2.4C13.9,14.4,13.6,15.2,13.1,15.9z M24.7,13.9
                            	c-0.1,0.8-0.3,1.4-0.8,2c-1.1,1.3-3,1.3-4.2,0c-0.6-0.7-0.8-1.4-0.8-2.3c0-0.9,0.3-1.7,1-2.4c1.1-1.1,2.9-1.1,4,0
                            	C24.5,12,24.8,12.9,24.7,13.9z" />
                </svg>
              </a>
              <a href="https://www.instagram.com/partyanimalsgame/" target="_blank" class="footer-icon-item footer-ins">
                <svg version="1.1" id="图层_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                  x="0px" y="0px" viewBox="0 0 25.3 25.4" style="fill: #c9bcb3; enable-background: new 0 0 25.3 25.4"
                  xml:space="preserve">
                  <path class="st0" d="M25.2,6.4c-0.1-1.8-1-3.5-2.5-4.7c-1.2-1-2.7-1.5-4.3-1.5C16.6,0.1,14.8,0,13,0h-2.9C8.7,0,7.3,0.1,5.9,0.3
                            	C3.3,0.6,1.1,2.5,0.4,5.1C0.1,6.3,0,7.5,0,8.8v6.6c0,1.2,0.1,2.5,0.2,3.7c0.2,3,2.4,5.5,5.3,6c1.1,0.2,2.1,0.3,3.2,0.3
                            	c2.2,0,4.5,0,6.7,0c1.3,0,2.7-0.1,4-0.2c2.7-0.3,4.9-2.3,5.5-4.9c0.3-1.2,0.4-2.4,0.4-3.6v-6.6C25.3,8.8,25.3,7.6,25.2,6.4z
                            	 M21.8,17.6c0,1.3-0.6,2.5-1.5,3.3c-0.8,0.6-1.7,1-2.8,1C15.3,22,13.7,22,11.4,22c-1.2,0-2.4,0-3.6-0.1c-0.5,0-0.9-0.1-1.3-0.3
                            	c-1.6-0.4-2.7-1.7-2.9-3.3c-0.1-0.8-0.2-1.7-0.2-2.5v-5.6c0-1.1,0.1-2.1,0.2-3.1c0.2-1.9,1.8-3.4,3.7-3.5C8.2,3.5,9.1,3.4,10,3.4
                            	c2.6,0,4.6,0,7.3,0.1c0.5,0,1.1,0.1,1.6,0.3c1.5,0.4,2.7,1.7,2.9,3.2c0.1,0.8,0.2,1.6,0.2,2.4v3l0,0C21.9,14.1,21.9,15.9,21.8,17.6
                            	L21.8,17.6z M12.7,6.5c-3.4,0-6.2,2.8-6.2,6.2s2.8,6.2,6.2,6.2c3.4,0,6.2-2.8,6.2-6.2C19,9.3,16.2,6.5,12.7,6.5
                            	C12.7,6.5,12.7,6.5,12.7,6.5z M12.7,16.1c-1.9,0-3.4-1.5-3.4-3.3s1.5-3.4,3.3-3.4c1.9,0,3.4,1.5,3.4,3.3c0,0,0,0,0,0l0,0
                            	C16,14.6,14.5,16,12.7,16.1L12.7,16.1z M18.9,4.8c-0.9,0-1.7,0.8-1.7,1.7c0,0.9,0.8,1.7,1.7,1.7c0.9,0,1.7-0.7,1.7-1.7
                            	C20.6,5.6,19.9,4.8,18.9,4.8C18.9,4.8,18.9,4.8,18.9,4.8z" />
                </svg>
              </a>
              <a href="https://www.facebook.com/PartyAnimalsGame/" target="_blank" class="footer-icon-item footer-fb">
                <!-- Generator: Adobe Illustrator 25.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
                <svg version="1.1" id="图层_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                  x="0px" y="0px" viewBox="0 0 24.1 24" style="fill: #c9bcb3; enable-background: new 0 0 24.1 24"
                  xml:space="preserve">
                  <path class="st0"
                    d="M15.7,24v-8.6h3.1l0.5-3.6h-3.5c0-0.6,0-2,0-2.6c0-0.9,0.7-1.6,1.6-1.6c0.3,0,1.1,0,2,0V4.5
                            c-0.4-0.1-1.2-0.1-2-0.2c-1.2-0.1-2.5-0.1-3.7,0.9c-1.2,0.9-1.7,2-1.7,4c0,0.6,0,1.9,0,2.6H8.9v3.6H12V24c-2.6,0-5.2,0-7.8,0
                            c-1.7,0-3.2-1-3.8-2.5C0.1,21,0,20.4,0,19.8C0,14.6,0,9.4,0,4.1c-0.1-2.2,1.7-4,3.9-4.1C4,0,4,0,4.1,0c5.2,0,10.5,0,15.7,0
                            c2.3,0,4.3,1.9,4.3,4.2c0,0,0,0,0,0.1c0,5.1,0,10.1,0,15.2c0.2,2.3-1.5,4.3-3.8,4.5c-0.2,0-0.5,0-0.7,0H15.7z" />
                  <image style="display: none; overflow: visible; opacity: 0.2" width="317" height="275"
                    transform="matrix(8.942100e-02 0 0 8.942100e-02 -0.576 2.8306)"></image>
                  <mask id="mask1" x="0" y="0" width="100" height="100">
                    <rect x="0" y="0" width="100" height="100" style="stroke: none; fill: #ffffff" />
                  </mask>
                </svg>
              </a>
              <a href="https://www.tiktok.com/@partyanimals" target="_blank" class="footer-icon-item footer-tiktok">
                <svg version="1.1" id="图层_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                  x="0px" y="0px" viewBox="0 0 25.3 25.3" style="fill: #c9bcb3; enable-background: new 0 0 25.3 25.3"
                  xml:space="preserve">
                  <path class="st0" d="M19.8,0H5.5C2.5,0,0,2.5,0,5.5v14.3c0,3,2.5,5.5,5.5,5.5h14.3c3,0,5.5-2.5,5.5-5.5V5.5C25.3,2.5,22.8,0,19.8,0z
                            	 M21.3,10.9c-1.7,0-3.4-0.6-4.7-1.5c0,0,0,6.7,0,6.9c0,3.4-2.8,6.2-6.2,6.2s-6.2-2.8-6.2-6.2s2.8-6.2,6.2-6.2c0.3,0,0.5,0,0.8,0.1
                            	v3.5c-0.3-0.1-0.5-0.1-0.8-0.1c-1.6,0-2.8,1.3-2.8,2.8s1.3,2.8,2.8,2.8s2.8-1.3,2.8-2.8c0,0,0,0,0,0h0V2.9h0h3.3h0v0.5
                            	c0.3,2.4,2.3,4.2,4.7,4.2V10.9z" />
                </svg>
              </a>

              <a href="https://www.youtube.com/c/PartyAnimalsGame" target="_blank"
                class="footer-icon-item footer-youtube">
                <svg version="1.1" id="图层_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                  x="0px" y="0px" viewBox="0 0 34.3 24.2" style="
                                              width: 32px;
                                              height: 22.5px;
                                              fill: #c9bcb3;
                                              enable-background: new 0 0 34.3 24.2;
                                            " xml:space="preserve">
                  <path d="M17.2,0c3.9,0.1,7.6,0.1,11.3,0.4c0.8,0.1,1.7,0.2,2.5,0.5c1.2,0.4,2,1.2,2.5,2.4c0.5,1.2,0.6,2.5,0.7,3.8
                            c0.2,2.2,0.3,4.5,0.2,6.7c-0.1,1.5-0.2,3.1-0.3,4.6c-0.1,0.9-0.2,1.8-0.6,2.6c-0.7,1.4-1.8,2.2-3.3,2.4c-3,0.5-6,0.5-9.1,0.5
                            c-1.8,0-3.7,0.1-5.5,0c-3.2,0-6.4-0.1-9.5-0.4c-0.8-0.1-1.7-0.2-2.5-0.5c-1.2-0.4-2.1-1.3-2.5-2.5c-0.4-1.1-0.5-2.3-0.6-3.4
                            c-0.2-2.3-0.3-4.6-0.2-6.9c0.1-1.7,0.2-3.3,0.4-5c0.1-1,0.2-1.9,0.7-2.8c0.7-1.3,1.8-2,3.2-2.2c2.6-0.4,5.2-0.5,7.8-0.5
                            C13.9,0,15.7,0,17.2,0z M13.7,17.2c0.1-0.1,0.2-0.1,0.3-0.2c1-0.6,2.1-1.2,3.1-1.8c1.7-1,3.5-2,5.2-3c0.1-0.1,0.2-0.1,0.2-0.2
                            c-0.1-0.1-0.2-0.2-0.2-0.2c-0.5-0.3-1-0.6-1.5-0.8c-2.1-1.2-4.2-2.4-6.3-3.6C14.2,7.3,14,7.2,13.7,7C13.7,10.4,13.7,13.8,13.7,17.2z
                            " />
                </svg>
              </a>
            </div>
          </div>
          <div class="logo">
            <h1 class="logo">
              <a v-if="this.$i18n.locale == 'zh'" href="https://partyanimals.cn"></a>
              <a v-if="this.$i18n.locale != 'zh'" href="https://partyanimals.com"></a>
            </h1>
          </div>
        </div>
      </div>
      <div class="text-box" :class="{ 'zh': $i18n.locale == 'zh' }">
        <div class="text-innerbox" :class="{ 'zh': $i18n.locale == 'zh' }">
          <p class="txt txt1 eula" v-if="$i18n.locale == 'en'" :style="{ position: 'relative', top: '-5px' }">

            <a href="https://partyanimals.com/user-agreement" class="txt-en-inline">User Agreement</a>
            <span class="divider"> | </span>
            <a href="https://partyanimals.com/privacy-policy" class="txt-en-inline">Privacy Policy</a>
            <span class="divider phone-clear"> | </span>
            <br class="phone-br" />
            <a href="https://partyanimals.com/fan-policy" class="txt-en-inline">Fan Content Policy</a>

          </p>
          <p class="txt txt1 eula" v-else :style="{ position: 'relative', top: '-5px' }">

            <a href="https://partyanimals.cn/user-agreement" class="txt-en-inline">用户协议</a>
            <span class="divider"> | </span>
            <a href="https://partyanimals.cn/privacy-policy" class="txt-en-inline">隐私政策</a>
            <span class="divider phone-clear"> | </span>
            <br class="phone-br" />
            <a href="https://partyanimals.cn/terms/children" class="txt-en-inline">儿童隐私政策</a>
            <span class="divider"> | </span>

            <a href="https://partyanimals.cn/fan-policy" class="txt-en-inline">粉丝内容政策</a>
            <span class="divider phone-clear"> | </span>
            <br class="phone-br" />
            <a href="https://partyanimals.cn/terms/sdk" class="txt-en-inline">第三方信息分享清单</a>

          </p>
          <p class="txt txt2" v-if="$i18n.locale == 'en'">
            <a href="mailto:Support@Recreate.Games" class="txt-en-inline">Support: Support@Recreate.Games</a>

            <span class="divider line2"> | </span>
            <a href="mailto:Media@Recreate.Games" class="txt-en-inline">Press: Media@Recreate.Games</a>

            <span class="divider line1"> | </span>
            <a href="mailto:Business@Recreate.Games" class="txt-en-inline">Business: Business@Recreate.Games</a>

          </p>
          <p class="txt txt2" v-if="$i18n.locale == 'zh'">
            <a href="mailto:Support@Recreate.Games" class="txt-en-inline">玩家支持: Support@Recreate.Games</a>

            <span class="divider line2"> | </span>
            <a href="mailto:Media@Recreate.Games" class="txt-en-inline">媒体和评测: Media@Recreate.Games</a>

            <span class="divider line1"> | </span>
            <a href="mailto:Business@Recreate.Games" class="txt-en-inline">商务合作: Business@Recreate.Games</a>

          </p>
          <p class="txt" v-if="$i18n.locale == 'zh'">
            <span class="txt-ib copyright txt-en">© {{ new Date().getFullYear() }} Source Technology 版权所有。 Recreate Games
              和 Party Animals 是
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" style=" fill: #bdb3aa;
                      fill-rule: evenodd;position: relative;top:3px" viewBox="0 0 20 20">
                <defs>

                </defs>
                <path id="矩形_1" data-name="矩形 1" class="cls-1"
                  d="M16.162,8.736h3.7A9.949,9.949,0,0,0,11.29.109V3.814A6.3,6.3,0,0,1,16.162,8.736ZM10,16.259A6.29,6.29,0,0,1,3.828,11.2h-3.7a9.944,9.944,0,0,0,19.735,0h-3.7A6.29,6.29,0,0,1,10,16.259ZM8.7,3.814V0.109A9.949,9.949,0,0,0,.128,8.736h3.7A6.3,6.3,0,0,1,8.7,3.814Z" />
              </svg> Source Technology, Inc. 或其关联方的注册商标。
            </span>


          </p>

          <p class="txt" v-if="$i18n.locale == 'en'">
            <span class="txt-ib copyright txt-en">© {{ new Date().getFullYear() }} Source Technology. Recreate Games and
              Party Animals are registered trademarks of
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" style=" fill: #bdb3aa;
                      fill-rule: evenodd;position: relative;top:3px" viewBox="0 0 20 20">
                <defs>

                </defs>
                <path id="矩形_1" data-name="矩形 1" class="cls-1"
                  d="M16.162,8.736h3.7A9.949,9.949,0,0,0,11.29.109V3.814A6.3,6.3,0,0,1,16.162,8.736ZM10,16.259A6.29,6.29,0,0,1,3.828,11.2h-3.7a9.944,9.944,0,0,0,19.735,0h-3.7A6.29,6.29,0,0,1,10,16.259ZM8.7,3.814V0.109A9.949,9.949,0,0,0,.128,8.736h3.7A6.3,6.3,0,0,1,8.7,3.814Z" />
              </svg> Source Technology, Inc. or its affiliates.
            </span>


          </p>
          <p class="txt" v-if="$i18n.locale == 'zh'">
            <span class="txt-ib copyright txt-en"><img src="../assets/images/cn.png" alt="">备案号：沪 ICP 备 2022007403
              号-1 上海市杨浦区黄兴路 2218 号 1 幢 32 层（名义层 35 层）01 室 联系电话：021-55829007
            </span>


          </p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import HoverBtn from "../components/HoverBtn.vue";
export default {
  components: { HoverBtn },
  name: "Footer",
  props: ["lang", "bg"],
  data() {
    return {
      isLangMenuActivated: false,
    };
  },
  mounted() {
    console.log();
    const localLang = localStorage.getItem("preferredLang");
    if (!localLang) {
      localStorage.setItem("preferredLang", this.lang);
    }
    document.addEventListener("click", this.closeLangMenu, false);
  },
  methods: {
    goSteam() {
      window.open('https://store.steampowered.com/app/1260320/')
    },
    showLangMenu(e) {
      e.stopPropagation();
      this.isLangMenuActivated = !this.isLangMenuActivated;
    },
    changeLang(lang) {
      localStorage.setItem("preferredLang", lang);
      this.$emit("setLang", lang);
    },
    closeLangMenu() {
      if (this.isLangMenuActivated) {
        this.isLangMenuActivated = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.logo {
  z-index: 900;

  a {
    position: relative;
    display: block;
    width: 112px;
    margin-left: 17px;
    top: 24px;
    height: 80px;
    background: image-set(url("../assets/images/logo.png") 1x, url("../assets/images/logo@2x.png") 2x) center top no-repeat;
    background-size: 100%;
    text-indent: -9999em;
  }
}

footer {
  position: relative;
  bottom: 0;
  width: 100%;
  /*height: 306px;*/

  line-height: 28px;
  font-family: 'Nunito-Bold', 'HYZhengYuan-85W', 'Microsoft YaHei', sans-serif;
  font-size: 13px;
  color: #bdb3aa;
  text-align: center;
  /*background: url("../images/wall.jpg") center bottom repeat-x;*/

  z-index: 0;

  .bg {
    background: url("../assets/images/submit_bg.png")center repeat;
    padding-top: 250px;
  }

  .search {
    background: none;
    padding-top: 150px;
  }

  .Bind {
    background: none;
    padding-top: 150px;
  }

  .MyTicket {
    padding-top: 150px;
    background: #faf9f4;
  }

  .Article {
    padding-top: 150px;
  }

  .Myticket {
    padding-top: 200px;
    background: #faf9f4;
  }

  .Serve,
  .search,
  .Article {
    background: #faf9f4;
  }

  .footer-icon-item {
    display: flex;
    align-items: center;
    align-content: center;
    flex-wrap: nowrap;
    flex-direction: row;
    justify-content: center;
    width: 44px;
    height: 45px;
    margin: 0 5px;
    background-repeat: no-repeat;
    background-size: 100%;
  }

  .Login ,.KNOW{
    background: none;
  }

  .ticket {
    background: none;
  }

  .Nfind {
    background: none;
  }

  .wall {

    z-index: 10;
    width: 100%;

    box-shadow: 0 5px 7px rgb(0 0 0 / 15%);
    background-image: url("../assets/images/common/footer.png");
    background-position: top;
    background-repeat: repeat-x;
    background-size: auto 100%;
  }

  .animals {
    width: 100%;
    position: relative;
    top: 2px;
  }
}

footer .phone-br {
  display: none;
}

.txt.txt1.eula a:hover,
.txt.txt2 a:hover {
  color: #f1e5dc;
}

.txt.txt1.eula a,
.txt.txt2 a {
  transition: all .2s;
}

footer .icon-box {
  display: flex;
  flex-direction: column-reverse;
  position: relative;

  align-items: flex-start;
}

footer .icon-list {
  display: flex;
  position: relative;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  align-content: center;
  margin-top: -0px;
}


/* footer .icon-list a svg {
    line-height: 44px;
} */

footer .txt {
  color: #bdb3aa;
}

footer .txt.eula {
  font-size: 16px;
}

footer .br {
  display: none;
}

footer .text-box .text-innerbox {
  position: relative;
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-content: center;
}

footer .icon .container {
  display: flex;
  max-width: 1080px;
  margin: 0 10%;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

footer .icon .container .logo {
  position: relative;
  top: -8px;
}

footer .wall {
  position: absolute;
  bottom: 0;
  height: 3.6vw;
  max-height: 36px;
  z-index: 1;

}

footer .text-box {
  background-color: #39322e;
  height: 200px;

  position: relative;

}

footer .icon {
  background-color: #4e443e;
  height: 140px;
  width: 100%;

  display: flex;
  justify-content: center;
}

.footer-animals {
  position: relative;
  margin-top: -126px;
  z-index: 10;

  img {
    position: relative;
    height: 11.8vw;
    max-height: 118px;
    // width: 90%;
    bottom: -11px;
  }
}

footer .txt {
  margin: 5px 30px 0;
}

footer .txt2 {
  /*margin-top: 5px;*/
  display: flex;
  justify-content: center;
  flex-direction: row;
  flex-wrap: wrap;
}

.copyright {
  /*max-width: 800px;*/
  display: inline-block;
  font-size: 12px;
  vertical-align: top;
  -moz-transform: scale(0.94);
  -webkit-transform: scale(0.94);
  transform: scale(0.94);

  img {
    position: relative;
    top: 5px;
    margin-right: 4px;
  }
}

footer .divider {
  display: inline-block;
  margin: 0 6px;
  vertical-align: top;
}

.lang-switcher-wrap {
  display: inline-block;
  position: relative;
  z-index: 12;
  width: 120px;
  height: 28px;
  /*margin-left: 18px;*/
  vertical-align: top;
  margin-top: 6px;
}

.lang-switcher {
  position: absolute;
  left: 0;
  top: 0;
  overflow: hidden;
  width: 120px;
  height: 28px;
  /*line-height: 28px;*/
  font-size: 14px;
  text-align: left;
  -webkit-border-radius: 14px;
  border-radius: 14px;
  background: #5f554e;
  color: #bdb3aa;
  transition: height ease-in .15s;
}

.lang-switcher:after {
  position: absolute;
  top: 12px;
  right: 10px;
  width: 0;
  height: 0;
  content: "";
  border-bottom: none;
  border-top: 4px solid #a49891;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
}

.lang-switcher.active {
  height: 54px;
}

.en.active .lang-options .lang-zh {
  opacity: 1;
}

.zh.active .lang-options .lang-en {
  opacity: 1;
}

.en .current-lang .lang-en {
  display: block;
}

.en .lang-options .lang-zh {
  display: block;
  opacity: 0;
}

.zh .current-lang .lang-zh {
  display: block;
}

.zh .lang-options .lang-en {
  display: block;
  opacity: 0;
}

[lang='en'] .copyright.txt-zh {
  display: none;
}

.copyright.txt-en {
  text-transform: none;
}

.lang-en,
.lang-zh {
  display: none;
  padding-left: 16px;
  width: 100%;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  ;
  box-sizing: border-box;
  cursor: pointer !important;
  transition: opacity ease-in .15s;
}

.current-lang {
  position: relative;
  display: block;
}

.lang-options {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 28px;
}


.footer-twitter {
  transition: all .2s ease;
  width: 33px !important;
  margin-right: 10px;
  position: relative;
  left: -12px;
  fill: #5c5f66;
}

.footer-twitter:hover {
  fill: #00a2fc;
}

.footer-twitter svg {
  width: 33px;
}

.footer-discord {
  transition: all .2s ease;
  width: 33px !important;
  position: relative;
  left: -5px;
  fill: #5c5f66;
}

.footer-discord:hover {
  fill: #6378d9;
}

.footer-ins img {
  margin: 0 1px;
  width: 35px;
}

.footer-ins .nom {
  transition: opacity 0.4s ease;
  opacity: 1;
}

.footer-tiktok {
  width: 33px;

}

[lang='zh'] .footer-en {
  display: none;
}

[lang='zh'] .footer-cn {
  display: flex;
}

[lang='en'] .footer-en {
  display: flex;
}

[lang='en'] .footer-cn {
  display: none;
}

.footer-weibo,
.footer-wechat {
  width: 34px;
}

.footer-tiktok svg {
  width: 29px;
}

.footer-ins svg {
  width: 30px;
}

.footer-fb {
  width: 30px;
  margin-right: 10px;
}

.footer-fb svg {
  width: 33px;
}

.footer-icon-item svg {
  opacity: .7;
  transition: all .3s;
}

.footer-icon-item:hover svg {
  opacity: 1;
}

.footer-ins .hov {
  position: absolute;
  cursor: pointer;
  left: 90px;
  opacity: 0;
  transition: opacity 0.4s ease;
}

.footer-ins:hover .nom {
  opacity: 0;
}

.footer-ins:hover .hov {
  opacity: 1;
  position: absolute;
  cursor: pointer;
}

.footer-fb {
  fill: #5c5f66;
  transition: all .2s ease;
}

.footer-fb:hover {
  fill: #2076ff;
}

.footer-fb svg {
  width: 28px !important;
  height: 28px;
}

.footer-tiktok img {
  width: 25px;
  margin-top: 1px;
  margin-left: -2px;
}

.footer-tiktok .nom {
  transition: opacity 0.4s ease;
  opacity: 1;
}

.footer-tiktok .hov {
  position: absolute;
  cursor: pointer;
  right: 55px;
  opacity: 0;
  transition: opacity 0.4s ease;
}

.footer-tiktok:hover .nom {
  opacity: 0;
}

.footer-tiktok:hover .hov {
  opacity: 1;
  position: absolute;
  cursor: pointer;
}


/* .footer-weibo {
    svg {
        fill: #5c5f66;
        width: 33px;

        path {
            transition: all 0.2s ease;
        }

        &:hover {
            .weibo-path1 {
                fill: #030405;
            }

            .weibo-path2 {
                fill: #e6162d;
            }

            .weibo-path3 {
                fill: #fb9734;
            }
        }
    }

    .nom {
        transition: opacity 0.4s ease;
        opacity: 1;
    }

    .hov {
        position: absolute;
        cursor: pointer;
        opacity: 0;
        transition: opacity 0.4s ease;
    }


} */

.footer-weibo:hover .nom {
  opacity: 0;
}

.footer-weibo:hover .hov {
  opacity: 1;
  position: absolute;
  cursor: pointer;
}

.footer-wechat {
  fill: #5c5f66;
  transition: all .2s ease;
}

.footer-wechat:hover {
  fill: #2aae67;
}

.footer-youtube {
  width: 29px !important;
  fill: #5c5f66;
  margin-left: 9px;
  transition: all .2s ease;
  position: relative;
  left: 5px;
}

.footer-youtube:hover {
  fill: #f46d5b;
}

.footer-bilibili {
  width: 44px !important;
  fill: #5c5f66;
  transition: all .2s ease;
}

.footer-cn a {
  margin: 0 6px;
}

.footer-bilibili svg {
  width: 32px !important;
  fill: #5c5f66;
  transition: all .2s ease;
}

.footer-bilibili:hover {
  fill: #00aeec;
}

.footer-wechat .qr-code {
  display: none;
  top: -150px;
  position: absolute;

  background-color: #f9f7f4;
  color: #4e443e;
  z-index: 20;

  box-shadow: 0px 4px 8px 0px rgb(0 0 0 / 10%), 0px 8px 16px 0px rgb(0 0 0 / 10%);
  line-height: 1;
}

.qr-code {
  display: none;
  position: absolute;
  top: 45px;
  left: 20px;
  z-index: 9;
  padding: 13px;
  font-size: 12px;
  -webkit-border-radius: 12px;
  background: #fff;
  margin-right: 110px;
}

.qr-code img {
  width: 100px;
}

.footer-wechat:hover .qr-code {
  display: block;
}



@media screen and (max-width:900px) {

  // .footer-animals img {
  //   height: 90px;
  //   bottom: -2px;
  // }
  footer .br {
    display: block;
  }
}

@media screen and (max-width:810px) {

  // footer .text-box {
  //   height: 240px;
  // }
  footer .divider.line1,
  footer .divider.line2 {
    display: none !important;
  }

  footer .text-box {
    height: 270px;
  }

  footer .txt2 {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: center;
  }
}

@media screen and (max-width:790px) {
  footer .phone-br {
    display: block;
  }

  footer .phone-clear {
    display: none;
  }

  footer .text-box {
    &.zh {
      height: 360px;
    }


  }
}

@media screen and (max-width:769px) {}

@media screen and (max-width:650px) {

  .footer-animals img {
    height: 11vw;
    bottom: -9px;
  }

  footer .icon .container {
    flex-direction: column;
    margin-top: 15px;
    justify-content: center;
  }

  footer .logo a {
    display: none;
  }
}


@media screen and (max-width:440px) {

  footer .text-box {
    height: 320px;

    &.zh {
      height: 440px;
    }



  }
}
</style>
